import { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@medifind/shared-basic-components';
import { Filter } from './Filter';

const DropDown = ({ onChange, classes = {}, what, label, smallAt, noHeader, items, placeholder, iconBefore, iconOnlyAt }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleChange = ({ value }) => {
    setSelectedItem(value);
    return onChange & onChange(value);
  };
  return (
    <Filter
      classes={classes}
      label={label}
      what={what}
      smallAt={smallAt}
      placeholder={placeholder ? placeholder : selectedItem && selectedItem.display}
      noHeader={noHeader}
    >
      <Select
        onChange={handleChange}
        label={label}
        hideLabel
        items={items}
        selectValue={selectedItem && selectedItem}
        classes={classes}
        placeholder={placeholder}
        iconBefore={iconBefore}
        iconOnlyAt={iconOnlyAt}
      />
    </Filter>
  );
};

DropDown.propTypes = {
  what: PropTypes.node,
  classes: PropTypes.object,
  label: PropTypes.string,
  smallAt: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      display: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
};
export { DropDown as default, DropDown };
